import { toPairs } from "lodash";
//import { BridgeDb, XrefsAnnotationPanel } from "bridgedb";
import { Validator } from "collit";
import * as React from "react";
// TODO look at how to properly import this so it works
// for both es5, esnext, tree-shaking, etc.
//import { Kaavio } from "kaavio";
import { Kaavio } from "kaavio/esnext/Kaavio";
// The edge drawing definitions are in Kaavio because they can be generically used.
// But the icons and markers are specific to Pvjs (less likely to useful to other applications).
import * as themePlain from "./themes/plain/theme";
import * as themeDark from "./themes/dark/theme";
// TODO make the CLI bundler include the styles
const ContainerCustomStyle = require("./themes/styles/Container.css");
const DiagramCustomStylePlain = require("./themes/styles/Diagram.plain.css");
const DiagramCustomStyleDark = require("./themes/styles/Diagram.dark.css");
const themeFor = {
    plain: Object.assign({ containerStyle: ContainerCustomStyle, diagramStyle: DiagramCustomStylePlain }, themePlain),
    dark: Object.assign({ containerStyle: ContainerCustomStyle, diagramStyle: DiagramCustomStyleDark }, themeDark)
};
// TODO use TS types updated for version 16. But I also have some changes
// I made for SVG attributes that need to get merged.
const Fragment = React["Fragment"];
// TODO move this into utils
// Create a string of citation numbers for display,
// delimited by commas, and
// replacing any consecutive series of numbers with the
// first and last joined by a hyphen.
function createPublicationXrefString(displayNumbers) {
    var publicationXrefString;
    if (displayNumbers.length === 1) {
        publicationXrefString = displayNumbers[0];
    }
    else {
        displayNumbers.sort(function (a, b) {
            return a - b;
        });
        var i = 0;
        publicationXrefString = displayNumbers[i].toString();
        if (displayNumbers.length > 2) {
            do {
                i += 1;
                if (displayNumbers[i - 1] + 1 !== displayNumbers[i] ||
                    displayNumbers[i] + 1 !== displayNumbers[i + 1]) {
                    if (i !== 1) {
                        if (displayNumbers[i - 2] + 2 === displayNumbers[i]) {
                            publicationXrefString += "-" + displayNumbers[i].toString();
                        }
                        else {
                            publicationXrefString += ", " + displayNumbers[i].toString();
                        }
                    }
                    else {
                        publicationXrefString += ", " + displayNumbers[i].toString();
                    }
                }
            } while (i < displayNumbers.length - 2);
        }
        i += 1;
        if (displayNumbers[i - 2] + 2 === displayNumbers[i]) {
            publicationXrefString += "-" + displayNumbers[i].toString();
        }
        else {
            publicationXrefString += ", " + displayNumbers[i].toString();
        }
    }
    return publicationXrefString;
}
function normalizeTargetValue(targetValue) {
    return targetValue.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
}
function cleanQueryParam(input) {
    return input.replace(/[^\w\-\:]/g, "");
}
// TODO reconcile query params and class props for pan/zoom settings
const pluralForOperationName = {
    highlight: "highlights",
    opacity: "opacities"
};
const parseForOperationName = {
    highlight: function (h) {
        if (Validator.isColor(h)) {
            return h;
        }
        const hexed = `#${h}`;
        if (Validator.isColor(hexed)) {
            return hexed;
        }
        else {
            console.warn(`Cannot parse color "${h}"`);
        }
    },
    opacity: parseFloat
};
function reconcileQueryParam(operationNameSingular, styleValuesByNormalizedTargetValues, queryParamKey, queryParamValue) {
    let result = [];
    if (queryParamKey.indexOf(`${operationNameSingular}-`) === 0) {
        const targetValue = queryParamKey.replace(`${operationNameSingular}-`, "");
        const normalizedTargetValue = normalizeTargetValue(targetValue);
        if (normalizedTargetValue in styleValuesByNormalizedTargetValues) {
            const prop = styleValuesByNormalizedTargetValues[normalizedTargetValue];
            console.warn(`Warning: "${operationNameSingular}" was specified by two different sources, which may or may not conflict.
				prop passed to Pvjs class:
					${operationNameSingular}={${JSON.stringify(prop)}}
				URL query param:
					${queryParamKey}=${queryParamValue}
				Setting URL query param to match prop passed to Pvjs class.`);
            const searchParams = new URLSearchParams(location.search);
            searchParams.set(queryParamKey, prop);
            history.replaceState({ queryParamKey }, document.title, "?" + searchParams.toString());
        }
        else {
            result.push([
                null,
                cleanQueryParam(targetValue),
                parseForOperationName[operationNameSingular](cleanQueryParam(queryParamValue))
            ]);
            //result = [null, normalizedTargetValue, queryParamValue];
        }
    }
    return result;
}
export class Pvjs extends React.Component {
    constructor(props) {
        super(props);
        this.handleEntityClick = entity => {
            const { onEntityClick, detailPanelEnabled = true } = this.props;
            if (onEntityClick)
                onEntityClick(entity);
            if (entity.type.indexOf("DataNode") > -1 &&
                entity.xrefIdentifier &&
                entity.xrefDataSource) {
                this.setState({ selected: entity, detailPanelOpen: detailPanelEnabled });
            }
        };
        const updatedProps = this.reconcileQueryParams(props);
        this.state = {
            detailPanelOpen: props.detailPanelOpen,
            selected: props.selected
        };
    }
    reconcileQueryParams(props) {
        // http://localhost:5983/?highlight-Cholesterol=yellow&highlight-ChEBI-35664=purple&highlight-hmdb-HMDB01206=blue&opacity-Dgat1=0&opacity-ncbigene-11303=0
        // ?highlight-Ensembl-ENSG00000121691=purple&highlight-HMDB-HMDB00193=yellow&highlight-PC=red
        // ?opacity-Ensembl-ENSG00000121691=1.5&opacity-HMDB-HMDB00193=0&opacity-PC=1.5
        const searchParams = Array.from(new URLSearchParams(location.search));
        return toPairs(pluralForOperationName)
            .reduce(function (acc, [operationNameSingular, operationNamePlural]) {
            const styleValuesByNormalizedTargetValues = props[operationNamePlural].reduce((acc, [targetKey, targetValue, styleValue]) => {
                acc[targetValue] = styleValue;
                return acc;
            }, {});
            acc.push({
                operationNameSingular,
                operationNamePlural,
                styleValuesByNormalizedTargetValues
            });
            return acc;
        }, [])
            .reduce(function (acc, { operationNameSingular, operationNamePlural, styleValuesByNormalizedTargetValues }) {
            searchParams.forEach(function ([queryParamKey, queryParamValue]) {
                reconcileQueryParam(operationNameSingular, styleValuesByNormalizedTargetValues, queryParamKey, queryParamValue).forEach(function (item) {
                    if (!(operationNamePlural in acc)) {
                        acc[operationNamePlural] = [];
                    }
                    acc[operationNamePlural].push(item);
                });
            });
            return acc;
        }, props);
        /*
        return toPairs(inputs)
          .reduce(
            function([inputKey, inputValue], { operationNameSingular, operationNamePlural, styleValuesByNormalizedTargetValues }) {
              searchParams.forEach(function(
                [queryParamKey, queryParamValue]
              ) {
                reconcileQueryParam(
                  operationNameSingular,
                  styleValuesByNormalizedTargetValues,
                  queryParamKey,
                  queryParamValue
                ).forEach(function(item) {
                  subAcc[operationNamePlural].push(item);
                });
                return subAcc;
              });
            return
            },
            {}
          );
    
        if (!isEmpty(parsed.highlights) || !isEmpty(parsed.opacities)) {
          const entitiesById = this.props.entitiesById;
          const mapper = values(entitiesById).reduce(function(acc, entity) {}, {});
        }
          //*/
    }
    closeActive() {
        this.setState({ selected: null, detailPanelOpen: false });
    }
    //componentWillMount() {}
    /*
    shouldComponentUpdate(nextProps, nextState) {
      const prevProps = this.props;
      const prevState = this.state;
  
      return [
        "pathway.id",
        "pathway.version",
        "selected",
        "detailPanelOpen",
        "theme"
      ].reduce(function(acc, item) {
        const getter = get(item);
        return acc || getter(prevState) !== getter(nextState);
      }, false);
    }
      //*/
    /*
    componentWillReceiveProps(nextProps) {
      const prevProps = this.props;
        const updatedProps = ["highlights", "opacities", "pathway", "entitiesById"]
        .filter(function(propId) {
            return prevProps[propId] !== nextProps[propId];
        });
      if (
        nextProps.wpId !== prevProps.wpId ||
        nextProps.version !== prevProps.version
      ) {
        // Reset the state
        this.setState({
          pathway: null,
          entitiesById: null,
          filter: null,
          detailPanelOpen: false,
          selected: null
        });
      }
    }
      //*/
    componentWillUnmount() {
        // TODO cancel any pending network requests, possibly something like this:
        // this.pathwayRequest.dispose();
    }
    onKaavioReady() {
        const { onReady } = this.props;
        if (onReady) {
            const { pathway, entitiesById } = this.state;
            onReady(entitiesById);
        }
    }
    handleCloseDetailsPanel() {
        this.setState({ detailPanelOpen: false });
    }
    renderDetailsPanel() {
        const { organism } = this.props.pathway;
        const { selected, detailPanelOpen } = this.state;
        if (!detailPanelOpen)
            return null;
        if (window.hasOwnProperty("XrefPanel")) {
            if (!!selected.xrefDataSource && !!selected.xrefIdentifier) {
                window["XrefPanel"]["show"](this.detailsPanelRef, selected.xrefIdentifier, selected.xrefDataSource, organism, {
                    "0": selected.textContent
                });
            }
        }
        /*
        return (
          <XrefsAnnotationPanel
            key="details-panel"
            bridgeDb={new BridgeDb()}
            organism={pvjson.organism}
            entityType={!!selected && selected.wpType}
            displayName={!!selected && selected.textContent}
            xrefDataSource={selected && selected.xrefDataSource}
            xrefIdentifier={!!selected && selected.xrefIdentifier}
            handleClose={_ => this.handleCloseDetailsPanel()}
          />
        );
        //*/
    }
    render() {
        const { pathway, entitiesById, theme, wpId, showPanZoomControls, highlights, opacities, zoomed, panned, panCoordinates, zoomLevel, onPanZoomChange, panZoomLocked } = this.props;
        return (React.createElement(Fragment, null,
            React.createElement("div", { ref: div => {
                    this.detailsPanelRef = div;
                } }),
            this.renderDetailsPanel(),
            React.createElement(Kaavio, { theme: themeFor[theme], pathway: pathway, entitiesById: entitiesById, onReady: kaavio => this.onKaavioReady(), onEntityClick: this.handleEntityClick, highlights: highlights, opacities: opacities, panned: panned, zoomed: zoomed, panCoordinates: panCoordinates, zoomLevel: zoomLevel, onPanZoomChange: onPanZoomChange, panZoomLocked: panZoomLocked, showPanZoomControls: showPanZoomControls })));
    }
}
Pvjs.defaultProps = {
    theme: "plain",
    opacities: [],
    highlights: [],
    panned: [],
    zoomed: [],
    pathway: {},
    entitiesById: {},
    detailPanelOpen: false,
    selected: null
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHZqcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9QdmpzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBT0wsT0FBTyxFQUVSLE1BQU0sUUFBUSxDQUFDO0FBRWhCLDREQUE0RDtBQUM1RCxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sUUFBUSxDQUFDO0FBQ25DLE9BQU8sS0FBSyxLQUFLLE1BQU0sT0FBTyxDQUFDO0FBRS9CLHVEQUF1RDtBQUN2RCwyQ0FBMkM7QUFDM0Msa0NBQWtDO0FBQ2xDLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUU5QyxtRkFBbUY7QUFDbkYsZ0dBQWdHO0FBQ2hHLE9BQU8sS0FBSyxVQUFVLE1BQU0sc0JBQXNCLENBQUM7QUFDbkQsT0FBTyxLQUFLLFNBQVMsTUFBTSxxQkFBcUIsQ0FBQztBQUNqRCwrQ0FBK0M7QUFDL0MsTUFBTSxvQkFBb0IsR0FBRyxPQUFPLENBQUMsK0JBQStCLENBQUMsQ0FBQztBQUN0RSxNQUFNLHVCQUF1QixHQUFHLE9BQU8sQ0FBQyxtQ0FBbUMsQ0FBQyxDQUFDO0FBQzdFLE1BQU0sc0JBQXNCLEdBQUcsT0FBTyxDQUFDLGtDQUFrQyxDQUFDLENBQUM7QUFFM0UsTUFBTSxRQUFRLEdBQUc7SUFDZixLQUFLLGtCQUNILGNBQWMsRUFBRSxvQkFBb0IsRUFDcEMsWUFBWSxFQUFFLHVCQUF1QixJQUNsQyxVQUFVLENBQ2Q7SUFDRCxJQUFJLGtCQUNGLGNBQWMsRUFBRSxvQkFBb0IsRUFDcEMsWUFBWSxFQUFFLHNCQUFzQixJQUNqQyxTQUFTLENBQ2I7Q0FDRixDQUFDO0FBRUYseUVBQXlFO0FBQ3pFLHFEQUFxRDtBQUNyRCxNQUFNLFFBQVEsR0FBRyxLQUFLLENBQUMsVUFBVSxDQUFDLENBQUM7QUFnQm5DLDRCQUE0QjtBQUM1QixtREFBbUQ7QUFDbkQsMkJBQTJCO0FBQzNCLHVEQUF1RDtBQUN2RCxxQ0FBcUM7QUFDckMsU0FBUywyQkFBMkIsQ0FBQyxjQUFjO0lBQ2pELElBQUkscUJBQXFCLENBQUM7SUFDMUIsSUFBSSxjQUFjLENBQUMsTUFBTSxLQUFLLENBQUMsRUFBRTtRQUMvQixxQkFBcUIsR0FBRyxjQUFjLENBQUMsQ0FBQyxDQUFDLENBQUM7S0FDM0M7U0FBTTtRQUNMLGNBQWMsQ0FBQyxJQUFJLENBQUMsVUFBUyxDQUFDLEVBQUUsQ0FBQztZQUMvQixPQUFPLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDZixDQUFDLENBQUMsQ0FBQztRQUNILElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUNWLHFCQUFxQixHQUFHLGNBQWMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLEVBQUUsQ0FBQztRQUVyRCxJQUFJLGNBQWMsQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFFO1lBQzdCLEdBQUc7Z0JBQ0QsQ0FBQyxJQUFJLENBQUMsQ0FBQztnQkFFUCxJQUNFLGNBQWMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxLQUFLLGNBQWMsQ0FBQyxDQUFDLENBQUM7b0JBQy9DLGNBQWMsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLEtBQUssY0FBYyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsRUFDL0M7b0JBQ0EsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFO3dCQUNYLElBQUksY0FBYyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsR0FBRyxDQUFDLEtBQUssY0FBYyxDQUFDLENBQUMsQ0FBQyxFQUFFOzRCQUNuRCxxQkFBcUIsSUFBSSxHQUFHLEdBQUcsY0FBYyxDQUFDLENBQUMsQ0FBQyxDQUFDLFFBQVEsRUFBRSxDQUFDO3lCQUM3RDs2QkFBTTs0QkFDTCxxQkFBcUIsSUFBSSxJQUFJLEdBQUcsY0FBYyxDQUFDLENBQUMsQ0FBQyxDQUFDLFFBQVEsRUFBRSxDQUFDO3lCQUM5RDtxQkFDRjt5QkFBTTt3QkFDTCxxQkFBcUIsSUFBSSxJQUFJLEdBQUcsY0FBYyxDQUFDLENBQUMsQ0FBQyxDQUFDLFFBQVEsRUFBRSxDQUFDO3FCQUM5RDtpQkFDRjthQUNGLFFBQVEsQ0FBQyxHQUFHLGNBQWMsQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFFO1NBQ3pDO1FBRUQsQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUVQLElBQUksY0FBYyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsR0FBRyxDQUFDLEtBQUssY0FBYyxDQUFDLENBQUMsQ0FBQyxFQUFFO1lBQ25ELHFCQUFxQixJQUFJLEdBQUcsR0FBRyxjQUFjLENBQUMsQ0FBQyxDQUFDLENBQUMsUUFBUSxFQUFFLENBQUM7U0FDN0Q7YUFBTTtZQUNMLHFCQUFxQixJQUFJLElBQUksR0FBRyxjQUFjLENBQUMsQ0FBQyxDQUFDLENBQUMsUUFBUSxFQUFFLENBQUM7U0FDOUQ7S0FDRjtJQUVELE9BQU8scUJBQXFCLENBQUM7QUFDL0IsQ0FBQztBQUVELFNBQVMsb0JBQW9CLENBQUMsV0FBVztJQUN2QyxPQUFPLFdBQVcsQ0FBQyxPQUFPLENBQUMsZUFBZSxFQUFFLEVBQUUsQ0FBQyxDQUFDLFdBQVcsRUFBRSxDQUFDO0FBQ2hFLENBQUM7QUFFRCxTQUFTLGVBQWUsQ0FBQyxLQUFhO0lBQ3BDLE9BQU8sS0FBSyxDQUFDLE9BQU8sQ0FBQyxZQUFZLEVBQUUsRUFBRSxDQUFDLENBQUM7QUFDekMsQ0FBQztBQUVELG9FQUFvRTtBQUNwRSxNQUFNLHNCQUFzQixHQUFHO0lBQzdCLFNBQVMsRUFBRSxZQUFZO0lBQ3ZCLE9BQU8sRUFBRSxXQUFXO0NBQ3JCLENBQUM7QUFDRixNQUFNLHFCQUFxQixHQUFHO0lBQzVCLFNBQVMsRUFBRSxVQUFTLENBQUM7UUFDbkIsSUFBSSxTQUFTLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxFQUFFO1lBQ3hCLE9BQU8sQ0FBQyxDQUFDO1NBQ1Y7UUFDRCxNQUFNLEtBQUssR0FBRyxJQUFJLENBQUMsRUFBRSxDQUFDO1FBQ3RCLElBQUksU0FBUyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsRUFBRTtZQUM1QixPQUFPLEtBQUssQ0FBQztTQUNkO2FBQU07WUFDTCxPQUFPLENBQUMsSUFBSSxDQUFDLHVCQUF1QixDQUFDLEdBQUcsQ0FBQyxDQUFDO1NBQzNDO0lBQ0gsQ0FBQztJQUNELE9BQU8sRUFBRSxVQUFVO0NBQ3BCLENBQUM7QUFDRixTQUFTLG1CQUFtQixDQUMxQixxQkFBcUIsRUFDckIsbUNBQW1DLEVBQ25DLGFBQWEsRUFDYixlQUFlO0lBRWYsSUFBSSxNQUFNLEdBQUcsRUFBRSxDQUFDO0lBQ2hCLElBQUksYUFBYSxDQUFDLE9BQU8sQ0FBQyxHQUFHLHFCQUFxQixHQUFHLENBQUMsS0FBSyxDQUFDLEVBQUU7UUFDNUQsTUFBTSxXQUFXLEdBQUcsYUFBYSxDQUFDLE9BQU8sQ0FBQyxHQUFHLHFCQUFxQixHQUFHLEVBQUUsRUFBRSxDQUFDLENBQUM7UUFDM0UsTUFBTSxxQkFBcUIsR0FBRyxvQkFBb0IsQ0FBQyxXQUFXLENBQUMsQ0FBQztRQUNoRSxJQUFJLHFCQUFxQixJQUFJLG1DQUFtQyxFQUFFO1lBQ2hFLE1BQU0sSUFBSSxHQUFHLG1DQUFtQyxDQUFDLHFCQUFxQixDQUFDLENBQUM7WUFDeEUsT0FBTyxDQUFDLElBQUksQ0FBQyxhQUFhLHFCQUFxQjs7T0FFOUMscUJBQXFCLEtBQUssSUFBSSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUM7O09BRTlDLGFBQWEsSUFBSSxlQUFlO2dFQUN5QixDQUFDLENBQUM7WUFFNUQsTUFBTSxZQUFZLEdBQUcsSUFBSSxlQUFlLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1lBQzFELFlBQVksQ0FBQyxHQUFHLENBQUMsYUFBYSxFQUFFLElBQUksQ0FBQyxDQUFDO1lBRXRDLE9BQU8sQ0FBQyxZQUFZLENBQ2xCLEVBQUUsYUFBYSxFQUFFLEVBQ2pCLFFBQVEsQ0FBQyxLQUFLLEVBQ2QsR0FBRyxHQUFHLFlBQVksQ0FBQyxRQUFRLEVBQUUsQ0FDOUIsQ0FBQztTQUNIO2FBQU07WUFDTCxNQUFNLENBQUMsSUFBSSxDQUFDO2dCQUNWLElBQUk7Z0JBQ0osZUFBZSxDQUFDLFdBQVcsQ0FBQztnQkFDNUIscUJBQXFCLENBQUMscUJBQXFCLENBQUMsQ0FDMUMsZUFBZSxDQUFDLGVBQWUsQ0FBQyxDQUNqQzthQUNGLENBQUMsQ0FBQztZQUNILDBEQUEwRDtTQUMzRDtLQUNGO0lBQ0QsT0FBTyxNQUFNLENBQUM7QUFDaEIsQ0FBQztBQUVELE1BQU0sT0FBTyxJQUFLLFNBQVEsS0FBSyxDQUFDLFNBQW1CO0lBZWpELFlBQVksS0FBZ0I7UUFDMUIsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBMEZmLHNCQUFpQixHQUFHLE1BQU0sQ0FBQyxFQUFFO1lBQzNCLE1BQU0sRUFBRSxhQUFhLEVBQUUsa0JBQWtCLEdBQUcsSUFBSSxFQUFFLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQztZQUNoRSxJQUFJLGFBQWE7Z0JBQUUsYUFBYSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1lBRXpDLElBQ0UsTUFBTSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxDQUFDO2dCQUNwQyxNQUFNLENBQUMsY0FBYztnQkFDckIsTUFBTSxDQUFDLGNBQWMsRUFDckI7Z0JBQ0EsSUFBSSxDQUFDLFFBQVEsQ0FBQyxFQUFFLFFBQVEsRUFBRSxNQUFNLEVBQUUsZUFBZSxFQUFFLGtCQUFrQixFQUFFLENBQUMsQ0FBQzthQUMxRTtRQUNILENBQUMsQ0FBQztRQXBHQSxNQUFNLFlBQVksR0FBRyxJQUFJLENBQUMsb0JBQW9CLENBQUMsS0FBSyxDQUFDLENBQUM7UUFFdEQsSUFBSSxDQUFDLEtBQUssR0FBRztZQUNYLGVBQWUsRUFBRSxLQUFLLENBQUMsZUFBZTtZQUN0QyxRQUFRLEVBQUUsS0FBSyxDQUFDLFFBQVE7U0FDekIsQ0FBQztJQUNKLENBQUM7SUFFRCxvQkFBb0IsQ0FBQyxLQUFLO1FBQ3hCLDBKQUEwSjtRQUMxSiw2RkFBNkY7UUFDN0YsK0VBQStFO1FBRS9FLE1BQU0sWUFBWSxHQUFHLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxlQUFlLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUM7UUFFdEUsT0FBTyxPQUFPLENBQUMsc0JBQXNCLENBQUM7YUFDbkMsTUFBTSxDQUFDLFVBQVMsR0FBRyxFQUFFLENBQUMscUJBQXFCLEVBQUUsbUJBQW1CLENBQUM7WUFDaEUsTUFBTSxtQ0FBbUMsR0FBRyxLQUFLLENBQy9DLG1CQUFtQixDQUNwQixDQUFDLE1BQU0sQ0FBQyxDQUFDLEdBQUcsRUFBRSxDQUFDLFNBQVMsRUFBRSxXQUFXLEVBQUUsVUFBVSxDQUFDLEVBQUUsRUFBRTtnQkFDckQsR0FBRyxDQUFDLFdBQVcsQ0FBQyxHQUFHLFVBQVUsQ0FBQztnQkFDOUIsT0FBTyxHQUFHLENBQUM7WUFDYixDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUM7WUFFUCxHQUFHLENBQUMsSUFBSSxDQUFDO2dCQUNQLHFCQUFxQjtnQkFDckIsbUJBQW1CO2dCQUNuQixtQ0FBbUM7YUFDcEMsQ0FBQyxDQUFDO1lBRUgsT0FBTyxHQUFHLENBQUM7UUFDYixDQUFDLEVBQUUsRUFBRSxDQUFDO2FBQ0wsTUFBTSxDQUFDLFVBQ04sR0FBRyxFQUNILEVBQ0UscUJBQXFCLEVBQ3JCLG1CQUFtQixFQUNuQixtQ0FBbUMsRUFDcEM7WUFFRCxZQUFZLENBQUMsT0FBTyxDQUFDLFVBQVMsQ0FBQyxhQUFhLEVBQUUsZUFBZSxDQUFDO2dCQUM1RCxtQkFBbUIsQ0FDakIscUJBQXFCLEVBQ3JCLG1DQUFtQyxFQUNuQyxhQUFhLEVBQ2IsZUFBZSxDQUNoQixDQUFDLE9BQU8sQ0FBQyxVQUFTLElBQUk7b0JBQ3JCLElBQUksQ0FBQyxDQUFDLG1CQUFtQixJQUFJLEdBQUcsQ0FBQyxFQUFFO3dCQUNqQyxHQUFHLENBQUMsbUJBQW1CLENBQUMsR0FBRyxFQUFFLENBQUM7cUJBQy9CO29CQUNELEdBQUcsQ0FBQyxtQkFBbUIsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztnQkFDdEMsQ0FBQyxDQUFDLENBQUM7WUFDTCxDQUFDLENBQUMsQ0FBQztZQUNILE9BQU8sR0FBRyxDQUFDO1FBQ2IsQ0FBQyxFQUNELEtBQUssQ0FBQyxDQUFDO1FBQ1Q7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O2NBMEJHO0lBQ0wsQ0FBQztJQUVELFdBQVc7UUFDVCxJQUFJLENBQUMsUUFBUSxDQUFDLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRSxlQUFlLEVBQUUsS0FBSyxFQUFFLENBQUMsQ0FBQztJQUM1RCxDQUFDO0lBZUQseUJBQXlCO0lBRXpCOzs7Ozs7Ozs7Ozs7Ozs7O1VBZ0JHO0lBRUg7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztVQXFCRztJQUVILG9CQUFvQjtRQUNsQiwwRUFBMEU7UUFDMUUsaUNBQWlDO0lBQ25DLENBQUM7SUFFRCxhQUFhO1FBQ1gsTUFBTSxFQUFFLE9BQU8sRUFBRSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUM7UUFDL0IsSUFBSSxPQUFPLEVBQUU7WUFDWCxNQUFNLEVBQUUsT0FBTyxFQUFFLFlBQVksRUFBRSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUM7WUFDN0MsT0FBTyxDQUFDLFlBQVksQ0FBQyxDQUFDO1NBQ3ZCO0lBQ0gsQ0FBQztJQUVELHVCQUF1QjtRQUNyQixJQUFJLENBQUMsUUFBUSxDQUFDLEVBQUUsZUFBZSxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7SUFDNUMsQ0FBQztJQUVELGtCQUFrQjtRQUNoQixNQUFNLEVBQUUsUUFBUSxFQUFFLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUM7UUFDeEMsTUFBTSxFQUFFLFFBQVEsRUFBRSxlQUFlLEVBQUUsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDO1FBQ2pELElBQUksQ0FBQyxlQUFlO1lBQUUsT0FBTyxJQUFJLENBQUM7UUFFbEMsSUFBSSxNQUFNLENBQUMsY0FBYyxDQUFDLFdBQVcsQ0FBQyxFQUFFO1lBQ3RDLElBQUksQ0FBQyxDQUFDLFFBQVEsQ0FBQyxjQUFjLElBQUksQ0FBQyxDQUFDLFFBQVEsQ0FBQyxjQUFjLEVBQUU7Z0JBQzFELE1BQU0sQ0FBQyxXQUFXLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FDekIsSUFBSSxDQUFDLGVBQWUsRUFDcEIsUUFBUSxDQUFDLGNBQWMsRUFDdkIsUUFBUSxDQUFDLGNBQWMsRUFDdkIsUUFBUSxFQUNSO29CQUNFLEdBQUcsRUFBRSxRQUFRLENBQUMsV0FBVztpQkFDMUIsQ0FDRixDQUFDO2FBQ0g7U0FDRjtRQUVEOzs7Ozs7Ozs7Ozs7O1lBYUM7SUFDSCxDQUFDO0lBRUQsTUFBTTtRQUNKLE1BQU0sRUFDSixPQUFPLEVBQ1AsWUFBWSxFQUNaLEtBQUssRUFDTCxJQUFJLEVBQ0osbUJBQW1CLEVBQ25CLFVBQVUsRUFDVixTQUFTLEVBQ1QsTUFBTSxFQUNOLE1BQU0sRUFDTixjQUFjLEVBQ2QsU0FBUyxFQUNULGVBQWUsRUFDZixhQUFhLEVBQ2QsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDO1FBRWYsT0FBTyxDQUNMLG9CQUFDLFFBQVE7WUFDUCw2QkFDRSxHQUFHLEVBQUUsR0FBRyxDQUFDLEVBQUU7b0JBQ1QsSUFBSSxDQUFDLGVBQWUsR0FBRyxHQUFHLENBQUM7Z0JBQzdCLENBQUMsR0FDRDtZQUVELElBQUksQ0FBQyxrQkFBa0IsRUFBRTtZQUUxQixvQkFBQyxNQUFNLElBQ0wsS0FBSyxFQUFFLFFBQVEsQ0FBQyxLQUFLLENBQUMsRUFDdEIsT0FBTyxFQUFFLE9BQU8sRUFDaEIsWUFBWSxFQUFFLFlBQVksRUFDMUIsT0FBTyxFQUFFLE1BQU0sQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLGFBQWEsRUFBRSxFQUN2QyxhQUFhLEVBQUUsSUFBSSxDQUFDLGlCQUFpQixFQUNyQyxVQUFVLEVBQUUsVUFBVSxFQUN0QixTQUFTLEVBQUUsU0FBUyxFQUNwQixNQUFNLEVBQUUsTUFBTSxFQUNkLE1BQU0sRUFBRSxNQUFNLEVBQ2QsY0FBYyxFQUFFLGNBQWMsRUFDOUIsU0FBUyxFQUFFLFNBQVMsRUFDcEIsZUFBZSxFQUFFLGVBQWUsRUFDaEMsYUFBYSxFQUFFLGFBQWEsRUFDNUIsbUJBQW1CLEVBQUUsbUJBQW1CLEdBQ3hDLENBQ08sQ0FDWixDQUFDO0lBQ0osQ0FBQzs7QUFoUU0saUJBQVksR0FBRztJQUNwQixLQUFLLEVBQUUsT0FBTztJQUNkLFNBQVMsRUFBRSxFQUFFO0lBQ2IsVUFBVSxFQUFFLEVBQUU7SUFDZCxNQUFNLEVBQUUsRUFBRTtJQUNWLE1BQU0sRUFBRSxFQUFFO0lBQ1YsT0FBTyxFQUFFLEVBQUU7SUFDWCxZQUFZLEVBQUUsRUFBRTtJQUNoQixlQUFlLEVBQUUsS0FBSztJQUN0QixRQUFRLEVBQUUsSUFBSTtDQUNmLENBQUMifQ==